export const PaymentModesEnum = {
  Cash: {
    key: 20693,
  },
  Cheque: {
    key: 20694,
  },
  BankTransfer: {
    key: 20695,
  },
  CreditCard: {
    key: 20696,
  },
  Draft: {
    key: 20697,
  },
  DepositBond: {
    key: 20698,
  },
  BankDeposit: {
    key: 20699,
  },
};
